export {};
//# sourceMappingURL=style-spec.js.map